import { NoSsr } from '@cian/react-utils';
import { UIText3 } from '@cian/ui-kit';
import lightFormat from 'date-fns/lightFormat';
import * as React from 'react';

import * as styles from './styles.css';

type TChatRemovalDateProps = {
  date: string;
};

export const ChatRemovalDate: React.FC<TChatRemovalDateProps> = ({ date }) => {
  const [removalDate, setRemovalDate] = React.useState('');

  React.useEffect(() => setRemovalDate(lightFormat(new Date(date), 'HH:mm dd.MM.yyyy')), [date]);

  return (
    <div className={styles['container']} data-testid="chat_removal_date">
      <UIText3 color="text-secondary-default">Объявление снято с публикации</UIText3>
      <NoSsr>
        <UIText3 color="text-secondary-default">{`в ${removalDate}`}</UIText3>
      </NoSsr>
    </div>
  );
};
